class DVHomeController {
    constructor(SettingsService, $routeParams) {
        this.$onInit = () => {
            this.state = {
                appSettings: null,
                enableRUF: false
            };
            this.rufUrl = 'RUF/test-execution/file-validation?embed=true';
            if (this.RouteParamService.testerId) {
                this.rufUrl += `&userId=${this.RouteParamService.testerId}`;
            }
            if (this.RouteParamService.simId) {
                this.rufUrl += `&simId=${this.RouteParamService.simId}`;
            }
            this.SettingsService.getSettings().then((settingsResponse) => {
                let appSettings = settingsResponse.data;
                this.state.appSettings = appSettings;
                this.state.enableRUF = appSettings.EnableRUF && appSettings.EnableRUFComponents.some(c => c.toLowerCase() === 'datavalidatorhome');
            });
        };
        this.SettingsService = SettingsService;
        this.RouteParamService = $routeParams;
    }
}
angular.module('app').component('dvHome', {
    bindings: {},
    templateUrl: 'scripts/app/partials/DataValidator/dv-home.tpl.html',
    controllerAs: 'vm',
    controller: DVHomeController
});
